import { render, staticRenderFns } from "./Screen4-2.vue?vue&type=template&id=f890ad0a&scoped=true&lang=html&"
import script from "./Screen4-2.vue?vue&type=script&lang=js&"
export * from "./Screen4-2.vue?vue&type=script&lang=js&"
import style0 from "./Screen4-2.vue?vue&type=style&index=0&id=f890ad0a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f890ad0a",
  null
  
)

export default component.exports